import React from "react";
import useApi from "storybook-dashboard/utils/fetching";
import Im from "immutable";

function CompanyInviteForm({ companyId, onSubmit }) {
  const { data: authGroups } = useApi("/api/company/{companyId}/authgroup/", { companyId });

  let authGroupOptions = (authGroups || Im.List()).map((ag) => (
    <option key={ag.get("uid")} value={ag.get("uid")}>
      {ag.get("name")}
    </option>
  ));

  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="col-7">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" className="form-control form-control-sm" id="email" name="email" />
          </div>
        </div>
        <div className="col-5">
          <div className="form-group">
            <label htmlFor="auth">Role</label>
            <select id="auth" name="auth" className="form-control form-control-sm">
              <option value="">Select a Role</option>
              {authGroupOptions}
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-7">
          <div className="form-group form-check">
            <input type="checkbox" className="form-check-input" id="pushToBelowCheck" name="meta_json__push_below" />
            <label className="form-check-label" htmlFor="pushToBelowCheck">
              Push To Below
            </label>
          </div>
        </div>
        <div className="col-5">
          <div className="form-group form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="autoAcceptCheck"
              name="meta_json__auto_accept_if_user_exists"
            />
            <label className="form-check-label" htmlFor="autoAcceptCheck">
              Auto-accept (if/when user exists)
            </label>
          </div>
        </div>
      </div>
      <button className="btn btn-sm btn-primary float-right" type="submit">
        Submit
      </button>
    </form>
  );
}

function ProjectInviteForm({ projectId }) {
  const { data: disciplines } = useApi("/api/project/{projectId}/discipline/", { projectId });

  let disciplineOptions = (disciplines || Im.List()).map((d) => (
    <option key={d.get("uid")} value={d.get("uid")}>
      {d.get("name")}
    </option>
  ));

  return (
    <form>
      <div className="row">
        <div className="form-group col-7">
          <label htmlFor="email">Email</label>
          <input type="email" className="form-control-sm" id="email" name="email" />
        </div>
        <div className="form-group col-5">
          <label htmlFor="auth">Supplier</label>
          <select id="project_discipline" name="project_discipline" className="form-control form-control-sm">
            <option value="">Select a Supplier</option>
            {disciplineOptions}
          </select>
        </div>
      </div>
      <div className="row">
        <div className="form-group col-5">
          <label htmlFor="autoAcceptCheck">Auto-accept (if/when user exists)</label>
          <input
            type="checkbox"
            className="form-control-sm"
            id="autoAcceptCheck"
            name="meta_json__auto_accept_if_user_exists"
          />
        </div>
      </div>
    </form>
  );
}

export default function InviteForm({ projectId, companyId, onSubmit }) {
  const Component = projectId ? ProjectInviteForm : CompanyInviteForm;
  return <Component {...{ projectId, companyId, onSubmit }} />;
}
